interface TrackingOrder {
  id: string;
  created_at: string;
  order_date?: string;
}

function timestampMicroseconds(value: string): bigint {
  const milliseconds = Date.parse(value);
  if (!Number.isFinite(milliseconds)) throw new Error('Invalid tracking order timestamp');
  const fraction = (value.match(/\.(\d+)(?:Z|[+-]\d{2}:\d{2})$/i)?.[1] || '').padEnd(6, '0');
  return BigInt(milliseconds) * 1000n + BigInt(fraction.slice(3, 6));
}

export function compareTrackingOrders(a: TrackingOrder, b: TrackingOrder): number {
  const first = timestampMicroseconds(a.created_at);
  const second = timestampMicroseconds(b.created_at);
  return (first < second ? -1 : first > second ? 1 : 0)
    || (b.order_date || '').localeCompare(a.order_date || '')
    || a.id.localeCompare(b.id);
}

export function getTrackingOrderId(orders: TrackingOrder[]): string | null {
  return [...orders].sort(compareTrackingOrders)[0]?.id ?? null;
}
